import './Language.sass';

import React, { FC, useMemo } from 'react';

import { Header, ScrollView, SelectList } from '$uikit';
import { useCurrentLang, useTranslator } from '$hooks';
import { changeLanguage } from '$translation';
import { SelectListOption } from '$uikit/SelectList/SelectList.interface';
import { LANGUAGE_MAP } from '$shared/constants/languages';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';

export const Language: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { key: currentLang } = useCurrentLang();

  const options: SelectListOption[] = useMemo(() => {
    return Object.entries(LANGUAGE_MAP).map(([key, language]) => {
      return {
        label: `${language} (${key.toUpperCase()})`,
        value: key,
      };
    });
  }, []);

  const handleChangeLanguage = async (lang) => {
    dispatch(toastActions.setToastLoading());

    changeLanguage(lang)
      .then(() => dispatch(toastActions.hideToast()))
      .catch(() => dispatch(toastActions.setToastFail()));
  };

  return (
    <>
      <Header showBackButton>{t('settings_language')}</Header>
      <ScrollView>
        <div className="Language">
          <SelectList
            description={t('settings_language_caption')}
            value={[currentLang]}
            options={options}
            onChange={([lang]) => handleChangeLanguage(lang)}
          />
        </div>
      </ScrollView>
    </>
  );
};

